<div class="content-container">
  <div class="content-container-bg"></div>
  <ng-container *ngIf="!embedUrl">
    <img
      title="Banner"
      class="content-container"
      [src]="isMobile ? banner.imagemMobile?.href : banner.imagem?.href"
    />
  </ng-container>
  <ng-container *ngIf="embedUrl && !isLiveModalOpen">
    <iframe
      title="Banner"
      class="content-container"
      *ngIf="embedUrl"
      width="100%"
      height="100%"
      [src]="embedUrl"
      frameborder="0"
      sandbox="allow-scripts allow-same-origin allow-presentation"
      allowfullscreen
      allow="autoplay"
    ></iframe>
  </ng-container>
  <div class="content">
    <div class="badges-container">
      <div
        class="transmission-badge transmission-type-badge"
        [ngClass]="dateLabel.type"
      >
        <span class="live-dot" *ngIf="dateLabel.type === 'live'"></span>
        <i class="bi bi-broadcast"></i>
        <span>{{ dateLabel.type === 'live' ? 'AO VIVO' : 'EM BREVE' }}</span>
      </div>
      <div
        class="transmission-badge transmission-date-badge"
        [ngClass]="dateLabel.type"
      >
        <i class="bi bi-calendar2-event-fill"></i>
        <span>{{ dateLabel.label }}</span>
      </div>
    </div>
    <h2 class="title">{{ banner.title }}</h2>
    <h3 class="subtitle" [innerHTML]="banner.subtitle"></h3>
    <div *ngIf="showCountdown" class="countdown">
      A live inicia em: <span>{{ countdown }}</span>
    </div>

    <button
      *ngIf="!showCountdown"
      class="button button-primary"
      [class.is-loading]="isSubscribing"
      [class.is-notified]="isNotified && !isSubscribing"
      (click)="onButtonClick(banner)"
      [disabled]="isNotified || isSubscribing"
    >
      <span *ngIf="dateLabel.type !== 'soon' || countdownExpired"
        ><i class="bi bi-play-fill"></i>Assistir Agora</span
      >
      <span
        *ngIf="dateLabel.type === 'soon' && !countdownExpired && isSubscribing"
        class="loading-dots"
        >...</span
      >
      <span
        *ngIf="
          dateLabel.type === 'soon' &&
          !countdownExpired &&
          !isSubscribing &&
          !isNotified
        "
        ><i class="bi bi-bell-fill"></i>Avise-me quando iniciar!</span
      >
      <span
        *ngIf="
          dateLabel.type === 'soon' &&
          !countdownExpired &&
          !isSubscribing &&
          isNotified
        "
        ><i class="bi bi-check-circle-fill"></i>Você será notificado</span
      >
    </button>
  </div>
</div>
